/* Get Joy — Chews PDP (v11). Buy box, gallery, interactions, plan state.
   Prices come from the Liquid config: each variant's Skio plan price (what renewals cost) and full price.
   First order = renewal price minus the checkout function's 44.46% (the same math FDR uses), so the page
   matches the cart to the cent. */
(function () {
  var root = document.querySelector('[data-gjc-root]');
  var cfgEl = document.querySelector('[data-gjc-config]');
  if (!root || !cfgEl) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var fmt = function (c) { return '$' + (c / 100).toFixed(2); };
  var setText = function (s, t) { var el = $(s); if (el && el.textContent !== t) el.textContent = t; };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var firstOf = function (renew) { return renew - Math.floor(renew * CFG.trialDiscount / 10000); };

  var avail = CFG.variants.filter(function (v) { return v.available; });
  var S = { v: (avail[0] || CFG.variants[0]), buyType: 'sub', freq: 4, addons: {}, plan: null, sticky: false };

  /* ---------- plan state (quiz) ---------- */
  function readQuiz() {
    var a = null;
    try {
      var raw = localStorage.getItem('gj_quiz_state_v1');
      if (raw) { var s = JSON.parse(raw); if (s && s.a && s.a.name && s.a.weight && (s.screen === 'plan' || s.screen === 'build')) a = s.a; }
    } catch (e) {}
    try {
      var p = new URLSearchParams(location.search);
      if (p.get('dog') && p.get('w')) { a = a || {}; a.name = p.get('dog'); a.weight = parseInt(p.get('w'), 10) || a.weight; }
    } catch (e) {}
    if (a) { a.name = String(a.name).replace(/[<>&"']/g, '').slice(0, 24); a.weight = Math.max(3, Math.min(200, parseInt(a.weight, 10) || 30)); }
    return a;
  }
  S.plan = readQuiz();
  var cpdFor = function (w) { return w <= 30 ? 1 : w <= 60 ? 2 : w <= 90 ? 3 : 4; };
  /* R58: bag (90 chews) lasts 90/45/30/22 days by size, so suggest every 8/6/4/3 weeks (only plans that exist) */
  var CAD = [8, 6, 4, 3], DAYS = [90, 45, 30, 22];
  function setTier(t) {
    S.tier = t;
    $$('[data-gjc-wt]').forEach(function (b) { b.setAttribute('aria-checked', +b.getAttribute('data-gjc-wt') === t ? 'true' : 'false'); });
    $$('[data-gjc-tier]').forEach(function (r) { r.classList.toggle('is-on', +r.getAttribute('data-gjc-tier') === t); });
    var want = CAD[t]; if (!S.v.plans[String(want)]) want = 4;
    S.freq = want; S.buyType = 'sub';
    var cpd = t + 1, out = $('[data-gjc=wt-out]');
    if (out) out.innerHTML = '<strong>' + cpd + ' chew' + (cpd > 1 ? 's' : '') + ' a day</strong> · one bag lasts about ' + DAYS[t] + ' days, so we set Auto-Ship to <strong>every ' + want + ' weeks</strong>. Change it anytime.';
    render();
  }

  /* ---------- prices ---------- */
  function prices() {
    var v = S.v, pl = v.plans[String(S.freq)] || v.plans['4'];
    var renew = pl ? pl.price : v.price;
    var first = firstOf(renew);
    var addonTotal = 0;
    $$('[data-gjc-addon]').forEach(function (b) {
      if (!S.addons[b.getAttribute('data-gjc-addon')]) return;
      var pe = b.parentNode.querySelector('.gjc-ad-price');
      var full = +pe.getAttribute('data-full'), r = +pe.getAttribute('data-renew');
      addonTotal += S.buyType === 'sub' ? firstOf(r) : full;
    });
    return { full: v.price, renew: renew, first: first, plan: pl, total: (S.buyType === 'sub' ? first : v.price) + addonTotal, addonTotal: addonTotal };
  }

  function render() {
    var d = prices(), wk = S.freq + ' weeks';
    $$('[data-gjc-variant]').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-gjc-variant') === S.v.id ? 'true' : 'false'); });
    $$('[data-gjc-buytype]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-gjc-buytype') === S.buyType ? 'true' : 'false'); });
    $$('[data-gjc-card]').forEach(function (c) { c.setAttribute('data-on', c.getAttribute('data-gjc-card') === S.buyType ? 'true' : 'false'); });
    $$('[data-gjc-freq]').forEach(function (b) { b.setAttribute('aria-checked', +b.getAttribute('data-gjc-freq') === S.freq ? 'true' : 'false'); });
    setText('[data-gjc=freq-val]', wk);
    setText('[data-gjc=stat-cadence]', 'every ' + wk);
    setText('[data-gjc=sub-first]', fmt(d.first));
    setText('[data-gjc=sub-terms]', 'Then ' + fmt(d.renew) + ' every ' + wk + ' (10% off) · skip, pause or cancel anytime');
    setText('[data-gjc=otp-price]', fmt(d.full));
    var label = 'Add to their routine — ' + fmt(d.total);
    setText('[data-gjc=cta-label]', label);
    setText('[data-gjc=close-cta-label]', label);
    setText('[data-gjc=sticky-price]', fmt(S.buyType === 'sub' ? d.first : d.full));
    var was = $('[data-gjc=sticky-was]'); if (was) { was.hidden = S.buyType !== 'sub'; was.textContent = fmt(d.full); }
    setText('[data-gjc=sticky-per]', S.buyType === 'sub' ? '· first bag, then ' + fmt(d.renew) : '· one bag');
    // add-on tiles follow the delivery choice (first-order price on subscribe)
    $$('.gjc-ad-price').forEach(function (pe) {
      var full = +pe.getAttribute('data-full'), r = +pe.getAttribute('data-renew');
      pe.textContent = S.buyType === 'sub' ? fmt(firstOf(r)) + ' first bag' : fmt(full);
    });
    $$('[data-gjc-addon]').forEach(function (b) {
      var on = !!S.addons[b.getAttribute('data-gjc-addon')];
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.textContent = on ? '✓ In your order' : 'Add to order';
    });
    var strip = $('[data-gjc=addon-strip]');
    if (strip) {
      var rows = $$('[data-gjc-addon]').filter(function (b) { return S.addons[b.getAttribute('data-gjc-addon')]; });
      strip.hidden = !rows.length;
      strip.innerHTML = rows.length ? '<div class="gjc-eyebrow">Also in your first order</div>' + rows.map(function (b) {
        var pe = b.parentNode.querySelector('.gjc-ad-price');
        return '<div class="gjc-strip-r"><span>' + esc(b.getAttribute('data-name')) + '</span><strong>' + esc(pe.textContent) + '</strong><button type="button" data-gjc-unadd="' + b.getAttribute('data-gjc-addon') + '" aria-label="Remove ' + esc(b.getAttribute('data-name')) + '">×</button></div>';
      }).join('') + '<div class="gjc-strip-t"><span>First order total</span><strong>' + fmt(d.total) + '</strong></div>' : '';
    }
    var rt = $('[data-gjc=routine-total]');
    if (rt) { rt.hidden = !d.addonTotal; setText('[data-gjc=routine-total-t]', 'Added to your first order · total ' + fmt(d.total)); }
    var st = $('[data-gjc=sticky]'); if (st) st.hidden = !S.sticky;
    var rp = $('[data-gjc=rep-price]'); if (rp) rp.textContent = fmt(Math.round(d.renew * 4 / (S.freq || 4))) + '/4 wks'; /* F02: same 4-week basis as the items it replaces */
  }

  /* ---------- plan-state copy ---------- */
  function renderPlan() {
    var a = S.plan, bt = $('[data-gjc=buy-title]');
    if (!a) return;
    var cpd = cpdFor(a.weight), cw = cpd === 1 ? 'chew' : 'chews';
    if (bt) bt.textContent = (bt.getAttribute('data-title-named') || "[name]'s daily chew").replace(/\[name\]/g, a.name);
    var chip = $('[data-gjc=profile-chip]');
    if (chip) { chip.hidden = false; $('[data-gjc=profile-line]').innerHTML = '<strong>' + esc(a.name) + '</strong> · ' + a.weight + ' lb · ' + cpd + ' ' + cw + ' a day'; }
    var dose = $('[data-gjc=dose]');
    if (dose) {
      dose.hidden = false;
      dose.innerHTML = '<span class="gjx-check" aria-hidden="true">✓</span><span><strong>' + cpd + ' ' + cw + ' a day</strong> for ' + esc(a.name) + ' at ' + a.weight + ' lb' + (CFG.reason ? ' · ' + esc(CFG.reason) : '') + '</span>';
    }
    var ans = $('[data-gjc=answer]');
    if (ans) ans.textContent = ans.textContent.replace(/^(A daily[^.]*?soft chew)/, '$1 for ' + a.name + ', ' + a.weight + ' lb,');
    var tier = cpd - 1;
    $$('[data-gjc-tier]').forEach(function (r) { r.classList.toggle('is-on', +r.getAttribute('data-gjc-tier') === tier); });
    setText('[data-gjc=sticky-title]', a.name + "'s " + (CFG.name || 'chews'));
    setText('[data-gjc=close-eyebrow]', a.name + "'s routine is ready");
  }

  /* ---------- gallery ---------- */
  var slides = $$('[data-gjc-slide]'), thumbs = $$('[data-gjc-thumb]'), gal = 0;
  /* R54: slides come from admin media; media tagged for another flavor carry data-off and are skipped */
  function galOn(s) { return !s.hasAttribute('data-off'); }
  function showSlide(i, dir) {
    var n = slides.length; if (!n) return;
    dir = dir || 1; i = ((i % n) + n) % n;
    for (var g = 0; g < n && !galOn(slides[i]); g++) i = (((i + dir) % n) + n) % n;
    gal = i;
    var gw = slides[0].closest('[data-gj-gal]');
    if (gw) { var fv = -1; for (var q = 0; q < n; q++) { if (galOn(slides[q])) { fv = q; break; } } gw.toggleAttribute('data-first', gal === fv); }
    slides.forEach(function (s, k) {
      var on = k === gal; s.hidden = !on;
      var vid = s.querySelector('video');
      if (vid) { if (on) { if (!vid.src && vid.getAttribute('data-src')) vid.src = vid.getAttribute('data-src'); } else { try { vid.pause(); } catch (e) {} } }
    });
    thumbs.forEach(function (t, k) { t.setAttribute('aria-pressed', k === gal ? 'true' : 'false'); });
  }
  function galFlavor(key) {
    key = String(key || '').toLowerCase();
    [slides, thumbs].forEach(function (L) { L.forEach(function (el) {
      var f = el.getAttribute('data-flavor'); if (f === null) return;
      if (f && key && f !== key) el.setAttribute('data-off', ''); else el.removeAttribute('data-off');
    }); });
    showSlide(0);
  }


  /* ---------- timeline (auto-advances until the shopper taps) ---------- */
  var stops = $$('.gjc-tl-stop'), tlUser = false, tlIdx = 0;
  function showStop(i) {
    tlIdx = i % stops.length;
    stops.forEach(function (b, j) { b.setAttribute('aria-selected', j === tlIdx ? 'true' : 'false'); });
    $$('[data-gjc-stop]').forEach(function (c) { c.hidden = +c.getAttribute('data-gjc-stop') !== tlIdx; });
  }
  if (stops.length > 1 && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    setInterval(function () { if (!tlUser && document.visibilityState === 'visible') showStop(tlIdx + 1); }, 3500);
  }

  function scrollToBuy() { var bb = $('[data-gjc-buybox]'); if (bb) bb.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  /* ---------- clicks ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('button, a') : null;
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-gjc-variant')) { var id = +t.getAttribute('data-gjc-variant'); S.v = CFG.variants.filter(function (v) { return v.id === id; })[0] || S.v; render(); }
    else if (t.hasAttribute('data-gjc-buytype')) { S.buyType = t.getAttribute('data-gjc-buytype'); render(); }
    else if (t.matches('[data-gjc=freq-toggle]')) {
      var chips = $('#gjc-freq-chips'), open = chips.hidden;
      chips.hidden = !open; t.setAttribute('aria-expanded', open ? 'true' : 'false'); t.textContent = open ? 'Done' : 'Change';
      if (S.buyType !== 'sub') { S.buyType = 'sub'; render(); }
    }
    else if (t.hasAttribute('data-gjc-wt')) setTier(+t.getAttribute('data-gjc-wt'));
    else if (t.hasAttribute('data-gjc-freq')) { S.freq = +t.getAttribute('data-gjc-freq'); S.buyType = 'sub'; render(); }
    else if (t.matches('[data-gjc=cta]')) addToCart(t);
    else if (t.hasAttribute('data-gjc-addon')) { var aid = t.getAttribute('data-gjc-addon'); S.addons[aid] = !S.addons[aid]; render(); }
    else if (t.hasAttribute('data-gjc-unadd')) { S.addons[t.getAttribute('data-gjc-unadd')] = false; render(); }
    else if (t.matches('[data-gjc=to-buy]')) scrollToBuy();
    else if (t.matches('[data-gjc=profile-chip]')) { location.href = (CFG.quizUrl || '/pages/quiz') + '?retake=1'; }
    else if (t.matches('[data-gjc=gal-prev]')) showSlide(gal - 1, -1);
    else if (t.matches('[data-gjc=gal-next]')) showSlide(gal + 1);
    else if (t.hasAttribute('data-gjc-thumb')) showSlide(+t.getAttribute('data-gjc-thumb'));
    else if (t.classList.contains('gjc-chip')) {
      var on = t.getAttribute('aria-pressed') !== 'true';
      $$('.gjc-chip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      var box = $('[data-gjc=active]');
      if (on) {
        t.setAttribute('aria-pressed', 'true');
        setText('[data-gjc=active-name]', t.textContent); setText('[data-gjc=active-dose]', t.getAttribute('data-dose') + ' / chew'); setText('[data-gjc=active-why]', t.getAttribute('data-why'));
      }
      box.hidden = !on;
    }
    else if (t.classList.contains('gjc-who-t')) {
      $$('.gjc-who-t').forEach(function (w) { w.setAttribute('aria-pressed', w === t ? 'true' : 'false'); });
      setText('[data-gjc=who-title]', t.getAttribute('data-title')); setText('[data-gjc=who-body]', t.getAttribute('data-body'));
    }
    else if (t.classList.contains('gjc-rchip')) {
      var tag = t.getAttribute('data-tag');
      $$('.gjc-rchip').forEach(function (c) { c.setAttribute('aria-pressed', c === t ? 'true' : 'false'); });
      $$('.gjc-rev').forEach(function (r) { r.hidden = !!tag && r.getAttribute('data-tag') !== tag; });
    }
    else if (t.classList.contains('gjc-tl-stop')) { tlUser = true; showStop(+t.getAttribute('data-i')); }
    else if (t.hasAttribute('data-gjc-vid')) {
      var pl = $('[data-gjc=vid-player]'), src = t.getAttribute('data-gjc-vid');
      var already = !pl.hidden && pl.getAttribute('data-src') === src;
      $$('[data-gjc-vid]').forEach(function (v) { v.classList.toggle('is-on', v === t && !already); });
      if (already) { pl.hidden = true; pl.innerHTML = ''; pl.removeAttribute('data-src'); return; }
      pl.setAttribute('data-src', src); pl.hidden = false;
      pl.innerHTML = '<div class="gjc-vp-media"><video src="' + esc(src) + '" autoplay playsinline controls></video><button type="button" data-gjc-vclose aria-label="Close video">×</button></div><div class="gjc-vp-cap"><p>' + esc(t.getAttribute('data-quote') || '') + '</p><strong>' + esc(t.getAttribute('data-who') || '') + '</strong></div>';
    }
    else if (t.hasAttribute('data-gjc-vclose')) { var p2 = $('[data-gjc=vid-player]'); p2.hidden = true; p2.innerHTML = ''; p2.removeAttribute('data-src'); $$('[data-gjc-vid]').forEach(function (v) { v.classList.remove('is-on'); }); }
    else if (t.matches('[data-gjc=vet-play]')) {
      var vsrc = t.getAttribute('data-src'); if (!vsrc) return;
      var vv = document.createElement('video'); vv.src = vsrc; vv.controls = true; vv.autoplay = true; vv.playsInline = true; vv.className = 'gjc-vet-video';
      t.replaceWith(vv);
    }
  });

  /* ---------- cart (same flow as FDR: add, then open the Rebuy drawer in place) ---------- */
  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    try { if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') window.Rebuy.Cart.fetchCart(); } catch (e) {}
    var trig = document.querySelector('.js-drawer-open-cart');
    if (trig) trig.click(); else window.location.href = '/cart';
  }
  function addToCart(btn) {
    var d = prices();
    var main = { id: S.v.id, quantity: 1, properties: {} };
    if (S.plan) { main.properties._dog_name = S.plan.name; main.properties._weight_lb = String(S.plan.weight); }
    if (S.buyType === 'sub' && d.plan) main.selling_plan = d.plan.id;
    var items = [main];
    $$('[data-gjc-addon]').forEach(function (b) {
      var vid = +b.getAttribute('data-gjc-addon');
      if (!S.addons[vid]) return;
      var it = { id: vid, quantity: 1 };
      if (S.buyType === 'sub' && d.plan) it.selling_plan = d.plan.id; // Skio plans are shared across the chew products
      items.push(it);
    });
    var orig = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Cart error'); }); return r.json(); })
      .then(function () {
        try { (window.dataLayer = window.dataLayer || []).push({ event: 'gjc_add_to_cart', chew: CFG.chew, type: S.buyType, weeks: S.buyType === 'sub' ? S.freq : 0, total: d.total / 100 }); } catch (e) {}
        btn.disabled = false; btn.textContent = '✓ Added to cart';
        setTimeout(function () { btn.innerHTML = orig; render(); }, 3000);
        openCart();
      })
      .catch(function (err) {
        btn.disabled = false; btn.innerHTML = orig; render();
        var el = $('[data-gjc=cart-error]'); if (el) { el.textContent = err.message || 'Something went wrong — please try again.'; el.hidden = false; setTimeout(function () { el.hidden = true; }, 5000); }
      });
  }

  /* ---------- sticky bar: after the buy box scrolls away, hidden while the close band is on screen ---------- */
  var bb = $('[data-gjc-buybox]'), close = $('.gjc-close'), raf = 0;
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      var past = bb && bb.getBoundingClientRect().bottom < 0;
      var cr = close && close.getBoundingClientRect();
      var atClose = cr && cr.top < window.innerHeight && cr.bottom > 0;
      var stick = !!past && !atClose;
      if (stick !== S.sticky) { S.sticky = stick; var st = $('[data-gjc=sticky]'); if (st) st.hidden = !stick; }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  renderPlan();
  if (S.plan) setTier(cpdFor(S.plan.weight) - 1);
  render();
  onScroll();
})();

/* R49 · swipe the product gallery on touch (taps the matching arrow) */
(function () {
  if (window.__gjSwipe) return; window.__gjSwipe = 1;
  document.addEventListener('touchstart', function (e) {
    var s = e.target.closest && e.target.closest('.gjc-gal-stage,.gjx-gal-frame');
    if (!s || e.touches.length > 1) return;
    var x0 = e.touches[0].clientX, y0 = e.touches[0].clientY;
    function end(ev) {
      s.removeEventListener('touchend', end);
      var t = ev.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        var b = s.querySelector(dx < 0 ? '[class*="gal-arrow--next"]' : '[class*="gal-arrow--prev"]');
        if (b) b.click();
      }
    }
    s.addEventListener('touchend', end, { passive: true });
  }, { passive: true });
})();
